module.exports = __webpack_public_path__ + "img/3-center-red.9f0e8e42.png";